import { render } from "./IconReports.vue?vue&type=template&id=3ab50cd9"
import script from "./IconReports.vue?vue&type=script&lang=js"
export * from "./IconReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__